import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

function Slider({
  className,
  ref,
  ...props
}: {
  ref?: React.Ref<React.ElementRef<typeof SliderPrimitive.Root>>
} & React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none items-center select-none",
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className="
          relative h-2 w-full grow overflow-hidden rounded-full bg-neutral-200
        "
      >
        <SliderPrimitive.Range className="absolute h-full bg-neutral-700" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className="
          block size-4 rounded-full border-2 border-neutral-400 bg-background
          ring-offset-background transition-colors
          focus-visible:ring-2 focus-visible:ring-ring
          focus-visible:ring-offset-2 focus-visible:outline-hidden
          disabled:pointer-events-none disabled:opacity-50
        "
      />
    </SliderPrimitive.Root>
  )
}

export { Slider }
